import React from 'react';
import { Link } from 'react-router-dom';
// import { getCoreServices } from '../data/services.js'; // Unused import removed
import CostComparisonTable from './CostComparisonTable';

const CoreServices = () => {
  // const coreServices = getCoreServices(); // Unused variable removed

  // Define the three main services to display
  const mainServices = [
    {
      id: 'generative-ai',
      icon: 'bi-cpu',
      title: 'Generative AI Solutions',
      subtitle: 'Production-Ready AI Applications',
      description: 'Build intelligent chatbots, content generators, and AI assistants that deliver immediate business value and enhance customer experience.',
      features: [
        'Custom LLM Integration',
        'RAG-Powered Knowledge Bases',
        'Multi-Modal AI Applications',
        'Enterprise Security & Compliance'
      ],
      gradient: 'linear-gradient(135deg, #0ea5e9 0%, #38bdf8 100%)',
      link: '/services/generative-ai',
      caseStudy: {
        title: 'Seez',
        result: '15% sales increase'
      }
    },
    {
      id: 'machine-learning',
      icon: 'bi-graph-up',
      title: 'Machine Learning & Analytics',
      subtitle: 'Data-Driven Decision Making',
      description: 'Transform your data into actionable insights with predictive models and automated analytics for better decision making.',
      features: [
        'Predictive Analytics',
        'Custom ML Models',
        'Real-time Data Processing',
        'Automated Reporting'
      ],
      gradient: 'linear-gradient(135deg, #0ea5e9 0%, #38bdf8 100%)',
      link: '/services/machine-learning',
      caseStudy: {
        title: 'Upwork Client Project',
        result: '95% detection accuracy'
      }
    },
    {
      id: 'staff-augmentation',
      icon: 'bi-people-fill',
      title: 'Staff Augmentation',
      subtitle: 'Flexible Team Extension',
      description: 'We provide skilled AI and technology professionals to augment your existing team, offering flexible staffing solutions that scale with your project needs and budget.',
      features: [
        'AI/ML Engineers & Data Scientists',
        'Full-Stack Developers',
        'DevOps Engineers & Cloud Specialists',
        'UI/UX Designers & Product Managers'
      ],
      gradient: 'linear-gradient(135deg, #0ea5e9 0%, #38bdf8 100%)',
      link: '/services/staff-augmentation',
      caseStudy: {
        title: 'Multiple Clients',
        result: '60-65% cost savings'
      }
    }
  ];


  return (
    <section className="core-services-section py-5" style={{
      background: 'linear-gradient(135deg, #f8fafc 0%, #ffffff 100%)',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Background Pattern */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: `
          radial-gradient(circle at 20% 80%, rgba(59, 130, 246, 0.03) 0%, transparent 50%),
          radial-gradient(circle at 80% 20%, rgba(30, 64, 175, 0.02) 0%, transparent 50%)
        `,
        zIndex: 1
      }}></div>

      <div className="container" style={{ position: 'relative', zIndex: 2 }}>
        <div className="row justify-content-center text-center mb-5">
          <div className="col-lg-8">
            <h2 style={{
              fontSize: 'clamp(2rem, 4vw, 3rem)',
              fontWeight: '700',
              color: '#334155',
              marginBottom: '1rem'
            }}>
              Solutions That{' '}
              <span style={{
                background: 'linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text'
              }}>Deliver Results</span>
            </h2>
            <p style={{
              fontSize: '1.1rem',
              color: '#737373',
              lineHeight: '1.6',
              maxWidth: '600px',
              margin: '0 auto'
            }}>
              Three proven service areas that address your most critical business challenges with measurable ROI.
            </p>
          </div>
        </div>

        <div className="row g-3 g-md-4">
          {mainServices.map((service, index) => (
            <div key={service.id} className="col-12 col-md-6 col-lg-4">
              <div style={{
                background: '#ffffff',
                border: '2px solid #94a3b8',
                borderRadius: 'clamp(16px, 3vw, 20px)',
                padding: 'clamp(1.5rem, 4vw, 2.5rem)',
                boxShadow: '0 10px 30px rgba(0, 0, 0, 0.08)',
                transition: 'all 0.3s ease',
                height: '100%',
                minHeight: 'clamp(500px, 80vw, 650px)',
                position: 'relative',
                overflow: 'hidden',
                display: 'flex',
                flexDirection: 'column'
              }}>
                {/* Responsive Grid Layout */}
                <div style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 'clamp(0.75rem, 2vw, 1rem)',
                  height: '100%'
                }}>
                  {/* Row 1: Icon + Title + Subtitle */}
                  <div style={{
                    minHeight: 'clamp(60px, 12vw, 70px)',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 'clamp(0.75rem, 2vw, 1rem)'
                  }}>
                    <div style={{
                      width: 'clamp(40px, 8vw, 50px)',
                      height: 'clamp(40px, 8vw, 50px)',
                      background: service.gradient,
                      borderRadius: 'clamp(8px, 2vw, 12px)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: 'white',
                      fontSize: 'clamp(1.2rem, 3vw, 1.5rem)',
                      flexShrink: 0,
                      boxShadow: '0 6px 15px rgba(0, 0, 0, 0.15)'
                    }}>
                      <i className={`bi ${service.icon}`}></i>
                    </div>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <h3 style={{
                        color: '#1e293b',
                        fontSize: 'clamp(1rem, 2.5vw, 1.2rem)',
                        fontWeight: '700',
                        marginBottom: '0.25rem',
                        lineHeight: '1.3',
                        margin: 0
                      }}>
                        {service.title}
                      </h3>
                      <p style={{
                        color: '#0ea5e9',
                        fontSize: 'clamp(0.8rem, 2vw, 0.9rem)',
                        fontWeight: '600',
                        margin: 0,
                        lineHeight: '1.3'
                      }}>
                        {service.subtitle}
                      </p>
                    </div>
                  </div>

                  {/* Row 2: Service Description */}
                  <div style={{
                    minHeight: 'clamp(80px, 15vw, 100px)',
                    display: 'flex',
                    alignItems: 'flex-start'
                  }}>
                    <p style={{
                      color: '#64748b',
                      fontSize: 'clamp(0.9rem, 2.2vw, 1rem)',
                      lineHeight: '1.6',
                      margin: 0
                    }}>
                      {service.description}
                    </p>
                  </div>

                  {/* Row 3: Key Features Heading */}
                  <div style={{
                    minHeight: 'clamp(30px, 6vw, 35px)',
                    display: 'flex',
                    alignItems: 'center'
                  }}>
                    <h6 style={{
                      color: '#374151',
                      fontSize: 'clamp(0.75rem, 2vw, 0.85rem)',
                      fontWeight: '600',
                      textTransform: 'uppercase',
                      letterSpacing: '0.5px',
                      margin: 0
                    }}>
                      Key Features
                    </h6>
                  </div>

                  {/* Row 4: Key Features List */}
                  <div style={{
                    minHeight: 'clamp(100px, 20vw, 140px)',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'flex-start'
                  }}>
                    <div style={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: 'clamp(0.375rem, 1vw, 0.5rem)'
                    }}>
                      {service.features.map((feature, fIndex) => (
                        <div key={fIndex} style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 'clamp(0.375rem, 1vw, 0.5rem)',
                          fontSize: 'clamp(0.8rem, 2vw, 0.9rem)',
                          color: '#64748b',
                          minHeight: 'clamp(20px, 4vw, 25px)',
                          lineHeight: '1.3'
                        }}>
                          <i className="bi bi-check-circle" style={{
                            color: '#10b981',
                            fontSize: 'clamp(0.7rem, 1.8vw, 0.8rem)',
                            flexShrink: 0
                          }}></i>
                          <span>{feature}</span>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Row 5: Case Study Preview */}
                  <div style={{
                    minHeight: 'clamp(60px, 12vw, 80px)',
                    display: 'flex',
                    alignItems: 'center'
                  }}>
                    <div style={{
                      background: '#f8fafc',
                      borderRadius: 'clamp(8px, 2vw, 12px)',
                      padding: 'clamp(0.75rem, 2vw, 1rem)',
                      border: '2px solid #94a3b8',
                      width: '100%',
                      height: '100%',
                      display: 'flex',
                      alignItems: 'center'
                    }}>
                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 'clamp(0.5rem, 1.5vw, 0.75rem)',
                        width: '100%'
                      }}>
                        <i className="bi bi-graph-up-arrow" style={{
                          color: '#10b981',
                          fontSize: 'clamp(1rem, 2.5vw, 1.2rem)',
                          flexShrink: 0
                        }}></i>
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div style={{
                            fontSize: 'clamp(0.8rem, 2vw, 0.9rem)',
                            fontWeight: '600',
                            color: '#1e293b',
                            lineHeight: '1.2'
                          }}>
                            {service.caseStudy.title}
                          </div>
                          <div style={{
                            fontSize: 'clamp(0.7rem, 1.8vw, 0.8rem)',
                            color: '#64748b',
                            lineHeight: '1.2'
                          }}>
                            {service.caseStudy.result}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Enhanced CTA Button */}
                <div style={{ marginTop: 'auto', paddingTop: 'clamp(0.75rem, 2vw, 1rem)' }}>
                  <Link to={service.link} style={{
                    background: service.gradient,
                    border: 'none',
                    color: '#ffffff',
                    padding: 'clamp(0.75rem, 2.5vw, 1rem) clamp(1.5rem, 4vw, 2rem)',
                    borderRadius: 'clamp(12px, 2.5vw, 15px)',
                    fontWeight: '700',
                    fontSize: 'clamp(0.9rem, 2.2vw, 1rem)',
                    textDecoration: 'none',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 'clamp(0.5rem, 1.5vw, 0.75rem)',
                    width: '100%',
                    transition: 'all 0.3s ease',
                    boxShadow: '0 6px 20px rgba(0, 0, 0, 0.15)',
                    position: 'relative',
                    overflow: 'hidden',
                    minHeight: 'clamp(44px, 8vw, 50px)'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.transform = 'translateY(-3px)';
                    e.target.style.boxShadow = '0 10px 30px rgba(0, 0, 0, 0.2)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = '0 6px 20px rgba(0, 0, 0, 0.15)';
                  }}>
                    <span>Learn More</span>
                    <i className="bi bi-arrow-right" style={{ 
                      fontSize: 'clamp(1rem, 2.5vw, 1.1rem)',
                      transition: 'transform 0.3s ease'
                    }}></i>
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Staffing Cost Advantage Table */}
        <CostComparisonTable 
          title="Staffing Cost Advantage"
          subtitle="Our offshore staffing reduces your development costs by 60-65% while delivering the same expertise and quality"
          showBadge={true}
          className="core-services-cost-table"
        />

        {/* View All Services CTA */}
        <div className="row justify-content-center mt-5">
          <div className="col-lg-8 text-center">
            <Link to="/services" style={{
              background: 'linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%)',
              border: 'none',
              color: '#ffffff',
              padding: '1.2rem 3rem',
              borderRadius: '50px',
              fontWeight: '700',
              fontSize: '1rem',
              textDecoration: 'none',
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '0.75rem',
              transition: 'all 0.3s ease',
              boxShadow: '0 8px 25px rgba(14, 165, 233, 0.4)',
              position: 'relative',
              overflow: 'hidden'
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 12px 35px rgba(14, 165, 233, 0.5)';
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 8px 25px rgba(14, 165, 233, 0.4)';
            }}>
              <i className="bi bi-grid-3x3-gap" style={{ fontSize: '1.2rem' }}></i>
              View All Services
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CoreServices; 